import {
  COUNTRY_REQUEST,
  COUNTRY_UPDATE,
  COUNTRY_REQUEST_SUCCESS,
  COUNTRY_REQUEST_ERROR,
  LOCATION_UPDATE,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_UPDATE_ERROR
} from '../actionCreators/locationActions';
import { LOCATION_SESSION_STORAGE_KEY } from '../config/config';
import countryData from '../config/countries.yaml';

// initialise country and currency from session storage if it's there
const storedLocation = sessionStorage.getItem(LOCATION_SESSION_STORAGE_KEY);

let country = null;
let currency = null;
let isoCode3 = null;

if (storedLocation) {
  try {
    const parsedLocation = JSON.parse(storedLocation);
    country = parsedLocation.country;
    currency = parsedLocation.currency;
    isoCode3 = parsedLocation.isoCode3;

    // The scribely main site sets the location session storage and it may not contain the 3 char isoCode
    if (!isoCode3) {
      isoCode3 = countryData.find(c => c.isoCode === country)?.isoCode3;
    }
  } catch (e) {
    console.info('Failed to parse location: defaulting to null');
  }
}

const initialState = {
  isLoading: false,
  error: null,
  country: country,
  locality: null,
  city: null,
  postalCode: null,
  currency: currency,
  isoCode3: isoCode3
};

function locationReducer(state = initialState, action) {
  switch (action.type) {
    case LOCATION_UPDATE:
      return {
        ...state,
        isLoading: true
      };

    case LOCATION_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        locality: action.locality,
        city: action.city,
        postalCode: action.postalCode
      };

    case COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case COUNTRY_UPDATE:
    case COUNTRY_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        locality: null,
        city: null,
        postalCode: null,
        country: action.result || action.country,
        currency: action.currency,
        isoCode3: action.isoCode3
      };

    case LOCATION_UPDATE_ERROR:
    case COUNTRY_REQUEST_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    default:
      return state;
  }
}

export default locationReducer;
